module.exports = __webpack_public_path__ + "media/images/wfc/venue-5-63820197fae30bc20b10bc99b5a4e30f.jpg";